import * as Yup from 'yup';

export const AddNewAirtimeAndDataBeneficiarySchema = Yup.object().shape({
  network: Yup.string().required('Select network'),
  phoneNumber: Yup.string().required('Enter valid phone number'),
  preferredName: Yup.string().required('Enter a name'),
});
